import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const PatientAreaChart = ({ data }) => {
  return (
    <div className="bg-white p-2 md:p-6 rounded-xl border border-slate-200 shadow-sm">
      <h3 className="text-lg font-semibold pl-2 mb-4">
        Patient Admissions Trend
      </h3>
      <div className="h-60 md:h-80">
        <ResponsiveContainer>
          <AreaChart data={data}>
            <defs>
              <linearGradient id="patients" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#3b82f6" stopOpacity={0.3} />
                <stop offset="95%" stopColor="#3b82f6" stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" vertical={false} />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            <Area
              type="monotone"
              dataKey="patients"
              stroke="#3b82f6"
              fill="url(#patients)"
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default PatientAreaChart;